module.exports = __webpack_public_path__ + "img/document-alt.9997d3aa.svg";